module.exports = __webpack_public_path__ + "static/media/skyline.0c17dd94.jpg";